module.exports = __webpack_public_path__ + "static/landing-img-a-493632411a42b0451221eb365665ac9b.svg";